module.exports = __webpack_public_path__ + "a66d3fa040e4ffa1384768965e640d40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/matthews_asia_funds.png
// module id = 1698
// module chunks = 0